// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3309":"96c850d3a0061d00","7846":"35dcbe0350e48c2a","8827":"f75379d1815aaa2e"}[chunkId] + ".css";
};